// Parse file chấm công -> { month, employees:[{ ma, ten, days:[{date,checkIn,checkOut,checkCount,weekday}] }] }.
// Hỗ trợ 2 ĐỊNH DẠNG (tự nhận diện):
//  - VP HN "BẢNG CHI TIẾT CHẤM CÔNG": mỗi NV có dòng "Mã nhân viên: … Tên: … Phòng ban: …",
//    ngày dạng dd/mm/yyyy, tối đa 6 mốc giờ (cột C–H). check-in = sớm nhất, check-out = muộn nhất.
//  - HCM "GIỜ CHẤM CÔNG": header lặp "Ngày|Thứ|Mã NV|Tên|Phòng ban|Chức vụ|Vào 1|Ra 1|Tổng giờ";
//    mỗi dòng = 1 ngày, mã/tên ở cột C/D, ngày dạng M/D/YY, 1 cặp Vào 1 / Ra 1 (cột G/H).
// Nạp SheetJS động để không phình bundle chính.
const toMin = (v) => {
  if (v === null || v === undefined || v === '') return null;
  const m = String(v).trim().match(/(\d{1,2}):(\d{2})/);
  return m ? Number(m[1]) * 60 + Number(m[2]) : null;
};
const hhmm = (m) => `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;
const p2 = (x) => String(x).padStart(2, '0');
const weekdayOf = (yy, mm, dd) => new Date(Number(yy), Number(mm) - 1, Number(dd)).getDay(); // 0=CN..6=T7

const reHead = /Mã nhân viên:\s*(\S+).*?Tên nhân viên:\s*(.+?)\s+Phòng ban:\s*(.+)/;

// VP HN: ngày dd/mm/yyyy. HCM: ngày M/D/YY (tháng/ngày/năm-2-số).
function parseVpHnDate(s) {
  const m = String(s || '').match(/^(\d{2})\/(\d{2})\/(\d{4})/);
  return m ? { date: `${m[3]}-${m[2]}-${m[1]}`, y: m[3], mo: m[2], d: m[1] } : null;
}
function parseHcmDate(s) {
  const m = String(s || '').trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/);
  if (!m) return null;
  const y = m[3].length === 2 ? `20${m[3]}` : m[3];
  return { date: `${y}-${p2(m[1])}-${p2(m[2])}`, y, mo: p2(m[1]), d: p2(m[2]) };
}

// ----- VP HN -----
function parseVpHn(rows) {
  const employees = [];
  let cur = null;
  let month = '';
  for (const r of rows) {
    const a = String(r[0] || '');
    const h = a.match(reHead);
    if (h) { cur = { ma: h[1], ten: h[2].trim(), pb: h[3].trim(), days: [] }; employees.push(cur); continue; }
    // Ngày có thể là dd/mm/yyyy (VP HN gốc) HOẶC M/D/YY (Excel lưu kiểu Date -> "4/1/26").
    const d = parseVpHnDate(a) || parseHcmDate(a);
    if (cur && d) {
      if (!month) month = `${d.y}-${d.mo}`;
      const times = [];
      for (let c = 2; c <= 7; c++) { const t = toMin(r[c]); if (t !== null) times.push(t); }
      cur.days.push({
        date: d.date,
        checkIn: times.length ? hhmm(Math.min(...times)) : '',
        checkOut: times.length ? hhmm(Math.max(...times)) : '',
        checkCount: times.length,
        weekday: weekdayOf(d.y, d.mo, d.d),
      });
    }
  }
  return { month, employees };
}

// ----- HCM -----
function parseHcm(rows) {
  const employees = [];
  const byMa = {};
  let month = '';
  for (const r of rows) {
    const ma = String(r[2] ?? '').trim();
    if (!ma || ma === 'Mã NV') continue; // bỏ header lặp + dòng tiêu đề
    const d = parseHcmDate(r[0]);
    if (!d) continue; // không phải dòng ngày
    if (!month) month = `${d.y}-${d.mo}`;
    if (!byMa[ma]) { byMa[ma] = { ma, ten: String(r[3] ?? '').trim(), pb: String(r[4] ?? '').trim(), days: [] }; employees.push(byMa[ma]); }
    // 1 cặp Vào 1 (G) / Ra 1 (H): lần đầu = check-in, lần sau = check-out.
    const times = [];
    for (const c of [6, 7]) { const t = toMin(r[c]); if (t !== null) times.push(t); }
    byMa[ma].days.push({
      date: d.date,
      checkIn: times.length ? hhmm(Math.min(...times)) : '',
      checkOut: times.length ? hhmm(Math.max(...times)) : '',
      checkCount: times.length,
      weekday: weekdayOf(d.y, d.mo, d.d),
    });
  }
  return { month, employees };
}

export async function parseAttendanceXlsx(arrayBuffer) {
  const XLSX = await import('xlsx');
  const wb = XLSX.read(arrayBuffer, { type: 'array', cellText: true, cellDates: false });
  const ws = wb.Sheets['Sheet1'] || wb.Sheets[wb.SheetNames[0]];
  const rows = XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, defval: '' });

  // Nhận diện định dạng: VP HN có dòng "Mã nhân viên: …"; HCM có header "Ngày … Mã NV".
  const isVpHn = rows.some((r) => reHead.test(String(r[0] || '')));
  if (isVpHn) return parseVpHn(rows);
  const isHcm = rows.some((r) => String(r[0] || '').trim() === 'Ngày' && String(r[2] || '').trim() === 'Mã NV');
  if (isHcm) return parseHcm(rows);
  // Mặc định thử VP HN (giữ tương thích file cũ).
  return parseVpHn(rows);
}
